// GETTERS
export const GET_QUEUE = 'fcfs/GET_QUEUE';
export const GET_QUEUE_LIST = 'fcfs/GET_QUEUE_LIST';
export const GET_LAST_QUEUE = 'fcfs/GET_LAST_QUEUE';


// MUTATORS
export const MUTATE_LIST_QUEUE = 'fcfs/MUTATE_LIST_QUEUE';
export const MUTATE_LAST_QUEUE = 'fcfs/MUTATE_LAST_QUEUE';
export const MUTATE_UPDATE_QUEUE_ITEM = 'fcfs/MUTATE_UPDATE_QUEUE_ITEM';
export const MUTATE_QUEUE = 'fcfs/MUTATE_QUEUE';
// export const MUTATE_ADD_QUEUE = 'fcfs/MUTATE_ADD_QUEUE';
// export const MUTATE_DELETE_QUEUE = 'fcfs/MUTATE_DELETE_QUEUE';


// ACTIONS
export const ACTION_LIST_QUEUE = 'fcfs/ACTION_LIST_QUEUE';
export const ACTION_GET_QUEUE = 'fcfs/ACTION_GET_QUEUE';
export const ACTION_ADD_QUEUE = 'fcfs/ACTION_ADD_QUEUE';
export const ACTION_DELETE_QUEUE = 'fcfs/ACTION_DELETE_QUEUE';
export const ACTION_GET_LAST_QUEUE = 'fcfs/ACTION_GET_LAST_QUEUE';
export const ACTION_UPDATE_QUEUE = 'fcfs/ACTION_UPDATE_QUEUE';





// WEBPACK FOOTER //
// ./src/store/constants/fcfs.js